module.exports = __webpack_public_path__ + "static/img/200132.9680f4b4.png";